// UppyButton
import React, { useEffect, useRef, useState } from 'react';
import Button, { ButtonProps } from '../Button';
import styles from './UppyButton.module.sass';
import cn from 'classnames';
import useTrendUppy, { TrendUppyProps } from 'hooks/useTrendUppy';

export interface UppyButtonProps extends ButtonProps {
  inputId: string;
  uppyProps: TrendUppyProps;
  uppyClassName?: string;
}

const UppyButton: React.FC<UppyButtonProps> = ({
  inputId,
  uppyProps,
  uppyClassName,
  ...buttonProps
}) => {
  const [hasListener, setHasListener] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  //   Uppy logic
  const uppy = useTrendUppy('UppyButton', uppyProps);

  useEffect(() => {
    if (!hasListener && fileInputRef.current) {
      const fileInput = fileInputRef.current;
      fileInput.addEventListener('change', (event) => {
        const files = Array.from((event as any).target.files);
        files.forEach((file: any) => {
          try {
            uppy.addFile({
              source: 'file input',
              name: file.name,
              type: file.type,
              data: file,
            });
          } catch (err: any) {
            if (err.isRestriction) {
              // handle restrictions
              console.log('Restriction error:', err);
            } else {
              // handle other errors
              console.error(err);
            }
          }
        });
      });
      setHasListener(true);
    }
  }, [fileInputRef]);

  return (
    <div className={cn(styles.uppyButton, uppyClassName)}>
      <Button {...buttonProps} />
      <label htmlFor={inputId}>
        <input type="file" id={inputId} ref={fileInputRef} />
      </label>
    </div>
  );
};

export default UppyButton;
